import React from 'react'
import { ThemeContextProvider } from './src/context/ThemeContext'

// Use wrapRootElement to match server-side implementation for proper hydration
export const wrapRootElement = ({ element }) => {
  return <ThemeContextProvider>{element}</ThemeContextProvider>
}

// Custom smooth scroll with easing function
const smoothScrollTo = (targetPosition, duration = 1000) => {
  const startPosition = window.pageYOffset
  const distance = targetPosition - startPosition
  let startTime = null

  const easeInOutCubic = (t) => {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2
  }

  const animation = (currentTime) => {
    if (startTime === null) startTime = currentTime
    const timeElapsed = currentTime - startTime
    const progress = Math.min(timeElapsed / duration, 1)
    const ease = easeInOutCubic(progress)

    window.scrollTo(0, startPosition + distance * ease)

    if (timeElapsed < duration) {
      requestAnimationFrame(animation)
    }
  }

  requestAnimationFrame(animation)
}

// Smooth scroll to anchor links
export const onRouteUpdate = ({ location }) => {
  if (location.hash) {
    setTimeout(() => {
      const element = document.querySelector(location.hash)
      if (element) {
        const targetPosition = element.offsetTop - 100 // Offset for fixed header
        smoothScrollTo(targetPosition, 1200)
      }
    }, 0)
  }
}

// Add smooth scroll to all anchor links
export const onClientEntry = () => {
  // Wait for React to hydrate
  window.addEventListener('load', () => {
    document.querySelectorAll('a[href^="/#"]').forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        e.preventDefault()
        const targetId = this.getAttribute('href').substring(2)
        const targetElement = document.getElementById(targetId)

        if (targetElement) {
          const targetPosition = targetElement.offsetTop - 100
          smoothScrollTo(targetPosition, 1200)

          // Update URL without triggering page reload
          window.history.pushState(null, null, `/#${targetId}`)
        }
      })
    })
  })
}
